import { useQuery } from '@tanstack/react-query';
import { FC, useEffect, useState } from 'react';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getServicesWithCategoriesAdmin } from '../../../network/admin';
import { getAllCategories } from '../../../network/category';
import { Button, Col, Form, Row, Select } from 'antd';
import { useIntl } from 'react-intl';
import { Category } from '../../../types/category';
import { FormInstance } from 'antd/lib';
import { service } from '../../../types/service';
import { PlusOutlined } from '@ant-design/icons';
import DeleteSVG from '../../../assets/common/DeleteSVG';
import IconSVG from '../../../assets/teamMember/IconSVG';

interface ServicesWithCategoriesSelectProps {
  selectedServices: {
    id: number;
    name: string;
    categoryId: number;
  }[];
  setSelectedServices: React.Dispatch<
    React.SetStateAction<
      {
        id: number;
        name: string;
        categoryId: number;
      }[]
    >
  >;
  selectedLocations: {
    id: number;
    key: number;
  }[];

  config: {
    isAdmin?: boolean;
    teamMemberId?: number;
    locationId: number;
    locationName?: string;
    isEdit?: boolean;
    salonName?: string;
  };
  form: FormInstance<any>;
}

const ServicesWithCategoriesSelect: FC<ServicesWithCategoriesSelectProps> = ({
  selectedServices,
  setSelectedServices,
  config,
  selectedLocations,
  form,
}) => {
  const intl = useIntl();

  const [selectedCategoryId, setSelectedCategoryId] = useState<null | number>(
    null
  );
  const { data: services, isLoading } = useQuery(
    [queryKeys.listCategories, selectedLocations],
    () => {
      const params = {
        with_parent: 1,
        with_location_services: config?.locationId,
        'location_ids[0]': config?.locationId,
      };
      if (config?.isAdmin) {
        return getServicesWithCategoriesAdmin(params);
      } else {
        return getAllCategories(params);
      }
    },
    {
      enabled: !!config?.locationId,
      select: (res) => {
        const data: any[] = [];
        res?.data?.map((category: { services: any[]; packages: any[] }) => {
          if (category?.services?.length > 0) {
            data.push(category);
          }
        });
        return data;
      },
    }
  );
  const getServicesOptions = () => {
    const categoryServices = services?.find(
      (category: {
        id: number;
        name: string;
        services: Array<{
          name: string;
          id: number;
        }>;
      }) => category?.id === selectedCategoryId
    );

    if (categoryServices) {
      return categoryServices?.services?.map(
        (service: {
          name: string;
          id: number;
          total_time: string;
          retail_price: string;
        }) => ({
          label: service?.name,
          value: service?.id,
          key: service?.id,
          disabled: !!selectedServices.find(
            (selectedPackage) => selectedPackage?.id === service?.id
          ),
        })
      );
    } else {
      return [];
    }
  };
  // const validateServices = () => {
  //   const newSelectedServices: {
  //     id: number;
  //     name: string;
  //     categoryId: number;
  //   }[] = [];
  //   selectedServices?.map((service) => {
  //     const existed = services?.find((category: { id: number }) => {
  //       return category?.id === service?.categoryId;
  //     });
  //     if (existed) {
  //       newSelectedServices.push(service);
  //     }
  //   });
  //   setSelectedServices(newSelectedServices);
  // };
  // useEffect(() => {
  //   if (services) {
  //     validateServices();
  //   }
  // }, [services]);
  const handleRemoveService = (serviceId: any) => {
    const newServices = selectedServices.filter(
      (item) => item.id !== serviceId
    );
    setSelectedServices(newServices);
  };
  return (
    <Form.List name="services">
      {(fields, { add, remove }) => (
        <>
          <Form.Item className="p-2 rounded bg-color-light-gr w-full text-color-primary">
            <div>
              <Row className="mb-4">
                <Col
                  className="gutter-row"
                  xl={24}
                  lg={8}
                  xs={24}
                  sm={24}
                  span={11}
                >
                  <label className="text-color-primary">
                    {intl.formatMessage({
                      id: 'servicesByMember',
                      defaultMessage: 'الخدمات المقدمة من العضو',
                    })}
                  </label>
                </Col>
              </Row>

              {fields.map(({ key, name, ...restField }, index) => (
                <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 15 }}>
                  <Col
                    className="gutter-row"
                    xl={11}
                    lg={11}
                    xs={22}
                    sm={10}
                    span={10}
                  >
                    <Form.Item
                      {...restField}
                      required={false}
                      label={intl.formatMessage({
                        id: 'service_category_label',
                      })}
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: 'service_category_required_message',
                          }),
                        },
                      ]}
                    >
                      <Select
                        loading={isLoading}
                        placeholder={intl.formatMessage({
                          id: 'service_category_placeholder',
                        })}
                        className="w-full my-input"
                        options={services?.map((item: Category) => ({
                          value: item?.id,
                          label: item?.name,
                        }))}
                        onChange={(value) => {
                          setSelectedCategoryId(value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xl={11}
                    lg={11}
                    xs={22}
                    sm={10}
                    span={10}
                  >
                    <Form.Item
                      {...restField}
                      required={false}
                      name={'services'}
                      label={intl.formatMessage({
                        id: 'service',
                        description: ' الخدمة',
                      })}
                      // rules={[{ required: true, message: "اختر الخدمة " }]}
                    >
                      <Select
                        className=""
                        loading={isLoading}
                        placeholder={intl.formatMessage({
                          id: 'selectService',
                          description: 'اختر الخدمة',
                        })}
                        options={getServicesOptions()}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xl={2}
                    lg={2}
                    xs={2}
                    sm={4}
                    span={2}
                  >
                    <Form.Item label=" ">
                      <Button
                        className="border-none bg-transparent shadow-none outline-none"
                        onClick={() => {
                          const selectedServiceId =
                            form.getFieldValue('services')['services'];
                          if (!selectedServiceId || !selectedCategoryId) {
                            return false;
                          }
                          const existedService = selectedServices?.find(
                            (service) =>
                              service?.id === parseInt(selectedServiceId)
                          );
                          if (existedService) return;
                          const category:
                            | {
                                id: number;
                                name: string;
                                services: service[];
                              }
                            | undefined = services?.find(
                            (category: {
                              id: number;
                              name: string;
                              services: service[];
                            }) => category?.id === selectedCategoryId
                          );
                          if (!category) {
                            return false;
                          }
                          const service = category?.services?.find(
                            (service) =>
                              service?.id === parseInt(selectedServiceId)
                          );
                          if (!service) {
                            return false;
                          }
                          setSelectedServices([
                            ...selectedServices,
                            {
                              id: parseInt(selectedServiceId),
                              name: service?.name,
                              categoryId: service?.service_category_id,
                            },
                          ]);
                          form.resetFields(['services']);
                        }}
                        block
                        icon={
                          <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                        }
                      ></Button>
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              <div>
                {selectedServices.map((service) => (
                  <>
                    <div
                      key={service?.id}
                      className="flex px-2 gap-2 my-1 bg-white p-1 justify-between rounded"
                    >
                      <div className="flex items-center ">
                        <div className="flex gap-2 items-center">
                          <span>
                            <IconSVG />
                          </span>
                          <span>{service?.name}</span>
                        </div>
                      </div>

                      <Button
                        type="text"
                        htmlType="button"
                        onClick={() => handleRemoveService(service.id)}
                      >
                        <DeleteSVG />
                      </Button>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

export default ServicesWithCategoriesSelect;
